import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "iq-sidebar sidebar-default" }
const _hoisted_3 = { class: "iq-sidebar-logo d-flex align-items-center justify-content-between" }
const _hoisted_4 = {
  class: "data-scrollbar",
  "data-scroll": "1"
}
const _hoisted_5 = { class: "iq-sidebar-menu" }
const _hoisted_6 = {
  id: "iq-sidebar-toggle",
  class: "iq-menu"
}
const _hoisted_7 = { class: "iq-top-navbar" }
const _hoisted_8 = { class: "iq-navbar-custom" }
const _hoisted_9 = { class: "navbar navbar-expand-lg navbar-light p-0" }
const _hoisted_10 = { class: "iq-navbar-logo d-flex align-items-center justify-content-between" }
const _hoisted_11 = { class: "d-flex align-items-center" }
const _hoisted_12 = {
  class: "collapse navbar-collapse",
  id: "navbarSupportedContent"
}
const _hoisted_13 = { class: "navbar-nav ml-auto navbar-list align-items-center" }
const _hoisted_14 = { class: "nav-item nav-icon dropdown caption-content" }
const _hoisted_15 = {
  class: "iq-sub-dropdown dropdown-menu",
  "aria-labelledby": "dropdownMenuButton"
}
const _hoisted_16 = { class: "card shadow-none m-0" }
const _hoisted_17 = { class: "card-body p-0 text-center" }
const _hoisted_18 = { class: "p-3" }
const _hoisted_19 = { class: "mb-1" }
const _hoisted_20 = { class: "d-flex align-items-center justify-content-center mt-3" }
const _hoisted_21 = { class: "content-page" }
const _hoisted_22 = {
  key: 0,
  class: "text-center"
}

import { ref, onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import apiClient from '../services/api'
import type { User, ApiError } from '../types'


export default /*@__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const router = useRouter()
const route = useRoute()
const user = ref<User | null>(null)
const loading = ref(true)

onMounted(async () => {
  try {
    const response = await apiClient.get<User>('/auth/me')
    user.value = {
      id: response.data.id,
      name: response.data.name,
      email: response.data.email,
      role: response.data.role
    }
  } catch (err: any) {
    localStorage.removeItem('authToken')
    localStorage.removeItem('authUser')
    router.push('/login')
  } finally {
    loading.value = false
  }
})

const handleLogout = async () => {
  try {
    await apiClient.post('/auth/logout')
  } catch (err) {
    // Proceed with logout even if API call fails
  } finally {
    localStorage.removeItem('authToken')
    localStorage.removeItem('authUser')
    router.push('/login')
  }
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          to: "/",
          class: "header-logo"
        }, {
          default: _withCtx(() => _cache[0] || (_cache[0] = [
            _createElementVNode("img", {
              src: "assets/images/real-estate.png",
              class: "img-fluid rounded-normal light-logo",
              alt: "logo"
            }, null, -1),
            _createElementVNode("h5", { class: "logo-title light-logo ml-3" }, "Estate Rwanda", -1)
          ])),
          _: 1
        }),
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "iq-menu-bt-sidebar ml-0" }, [
          _createElementVNode("i", { class: "las la-bars wrapper-menu" })
        ], -1))
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("nav", _hoisted_5, [
          _createElementVNode("ul", _hoisted_6, [
            _createElementVNode("li", {
              class: _normalizeClass({ active: _ctx.$route.name === 'DashboardItem' })
            }, [
              _createVNode(_component_router_link, {
                to: "/",
                class: "svg-icon"
              }, {
                default: _withCtx(() => _cache[2] || (_cache[2] = [
                  _createElementVNode("svg", {
                    class: "svg-icon",
                    width: "20",
                    height: "20",
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }, [
                    _createElementVNode("path", { d: "M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" }),
                    _createElementVNode("polyline", { points: "3.27 6.96 12 12.01 20.73 6.96" }),
                    _createElementVNode("line", {
                      x1: "12",
                      y1: "22.08",
                      x2: "12",
                      y2: "12"
                    })
                  ], -1),
                  _createElementVNode("span", { class: "ml-4" }, "Dashboard", -1)
                ])),
                _: 1
              })
            ], 2),
            _createElementVNode("li", {
              class: _normalizeClass({ active: _ctx.$route.name === 'AgentsItem' })
            }, [
              _createVNode(_component_router_link, {
                to: "/agents",
                class: "svg-icon"
              }, {
                default: _withCtx(() => _cache[3] || (_cache[3] = [
                  _createElementVNode("svg", {
                    class: "svg-icon",
                    width: "20",
                    height: "20",
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }, [
                    _createElementVNode("path", { d: "M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" }),
                    _createElementVNode("circle", {
                      cx: "9",
                      cy: "7",
                      r: "4"
                    }),
                    _createElementVNode("path", { d: "M23 21v-2a4 4 0 0 0-3-3.87" }),
                    _createElementVNode("path", { d: "M16 3.13a4 4 0 0 1 0 7.75" })
                  ], -1),
                  _createElementVNode("span", { class: "ml-4" }, "Agent Management", -1)
                ])),
                _: 1
              })
            ], 2),
            _createElementVNode("li", {
              class: _normalizeClass({ active: _ctx.$route.name === 'PropertiesItem' })
            }, [
              _createVNode(_component_router_link, {
                to: "/properties",
                class: "svg-icon"
              }, {
                default: _withCtx(() => _cache[4] || (_cache[4] = [
                  _createElementVNode("svg", {
                    class: "svg-icon",
                    width: "20",
                    height: "20",
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }, [
                    _createElementVNode("path", { d: "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" }),
                    _createElementVNode("polyline", { points: "14 2 14 8 20 8" }),
                    _createElementVNode("line", {
                      x1: "16",
                      y1: "13",
                      x2: "8",
                      y2: "13"
                    }),
                    _createElementVNode("line", {
                      x1: "16",
                      y1: "17",
                      x2: "8",
                      y2: "17"
                    }),
                    _createElementVNode("polyline", { points: "10 9 9 9 8 9" })
                  ], -1),
                  _createElementVNode("span", { class: "ml-4" }, "Property Management", -1)
                ])),
                _: 1
              })
            ], 2)
          ])
        ]),
        _cache[5] || (_cache[5] = _createStaticVNode("<div id=\"sidebar-bottom\" class=\"position-relative sidebar-bottom\" data-v-11d430a1><div class=\"card border-none\" data-v-11d430a1><div class=\"card-body p-0\" data-v-11d430a1><div class=\"sidebarbottom-content\" data-v-11d430a1><div class=\"image\" data-v-11d430a1><img src=\"assets/images/layouts/side-bkg.png\" class=\"img-fluid\" alt=\"side-bkg\" data-v-11d430a1></div><h6 class=\"mt-4 px-4 body-title\" data-v-11d430a1> Need Professional website call Tamba Group +250 789 326 245 </h6><button type=\"button\" class=\"btn sidebar-bottom-btn mt-4\" data-v-11d430a1> Learn More </button></div></div></div></div><div class=\"p-3\" data-v-11d430a1></div>", 2))
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("nav", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _cache[7] || (_cache[7] = _createElementVNode("i", { class: "ri-menu-line wrapper-menu" }, null, -1)),
            _createVNode(_component_router_link, {
              to: "/dashboard",
              class: "header-logo"
            }, {
              default: _withCtx(() => _cache[6] || (_cache[6] = [
                _createElementVNode("img", {
                  src: "assets/images/logo.png",
                  class: "img-fluid rounded-normal",
                  alt: "logo"
                }, null, -1),
                _createElementVNode("h5", { class: "logo-title ml-3" }, "Tamba Estate Admin", -1)
              ])),
              _: 1
            })
          ]),
          _cache[13] || (_cache[13] = _createStaticVNode("<div class=\"iq-search-bar device-search\" data-v-11d430a1><form action=\"#\" class=\"searchbox\" data-v-11d430a1><a class=\"search-link\" href=\"#\" data-v-11d430a1><i class=\"ri-search-line\" data-v-11d430a1></i></a><input type=\"text\" class=\"text search-input\" placeholder=\"Search here...\" data-v-11d430a1></form></div>", 1)),
          _createElementVNode("div", _hoisted_11, [
            _cache[12] || (_cache[12] = _createElementVNode("button", {
              class: "navbar-toggler",
              type: "button",
              "data-toggle": "collapse",
              "data-target": "#navbarSupportedContent",
              "aria-controls": "navbarSupportedContent",
              "aria-label": "Toggle navigation"
            }, [
              _createElementVNode("i", { class: "ri-menu-3-line" })
            ], -1)),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("ul", _hoisted_13, [
                _createElementVNode("li", _hoisted_14, [
                  _cache[11] || (_cache[11] = _createElementVNode("a", {
                    href: "#",
                    class: "search-toggle dropdown-toggle",
                    id: "dropdownMenuButton4",
                    "data-toggle": "dropdown",
                    "aria-haspopup": "true",
                    "aria-expanded": "false"
                  }, [
                    _createElementVNode("img", {
                      src: "assets/images/user/1.png",
                      class: "img-fluid rounded",
                      alt: "user"
                    })
                  ], -1)),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _cache[10] || (_cache[10] = _createElementVNode("div", { class: "media-body profile-detail text-center" }, [
                          _createElementVNode("img", {
                            src: "assets/images/page-img/profile-bg.jpg",
                            alt: "profile-bg",
                            class: "rounded-top img-fluid mb-4"
                          }),
                          _createElementVNode("img", {
                            src: "assets/images/user/1.png",
                            alt: "profile-img",
                            class: "rounded profile-img img-fluid avatar-70"
                          })
                        ], -1)),
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("h5", _hoisted_19, _toDisplayString(user.value?.email || 'Loading...'), 1),
                          _cache[9] || (_cache[9] = _createElementVNode("p", { class: "mb-0" }, "Since May 12, 2025", -1)),
                          _createElementVNode("div", _hoisted_20, [
                            _createVNode(_component_router_link, {
                              to: "/profile",
                              class: "btn border mr-2"
                            }, {
                              default: _withCtx(() => _cache[8] || (_cache[8] = [
                                _createTextVNode("Profile")
                              ])),
                              _: 1
                            }),
                            _createElementVNode("a", {
                              href: "#",
                              class: "btn border",
                              onClick: _withModifiers(handleLogout, ["prevent"])
                            }, "Sign Out")
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_21, [
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_22, _cache[14] || (_cache[14] = [
            _createElementVNode("div", {
              class: "spinner-border text-primary",
              role: "status"
            }, [
              _createElementVNode("span", { class: "sr-only" }, "Loading...")
            ], -1)
          ])))
        : (_openBlock(), _createBlock(_component_router_view, {
            key: 1,
            name: "dashboard"
          }))
    ]),
    _cache[15] || (_cache[15] = _createStaticVNode("<footer class=\"iq-footer\" data-v-11d430a1><div class=\"container-fluid\" data-v-11d430a1><div class=\"card\" data-v-11d430a1><div class=\"card-body\" data-v-11d430a1><div class=\"row\" data-v-11d430a1><div class=\"col-lg-6\" data-v-11d430a1><ul class=\"list-inline mb-0\" data-v-11d430a1><li class=\"list-inline-item\" data-v-11d430a1><a href=\"#\" data-v-11d430a1>Privacy Policy</a></li><li class=\"list-inline-item\" data-v-11d430a1><a href=\"#\" data-v-11d430a1>Terms of Use</a></li></ul></div><div class=\"col-lg-6 text-right\" data-v-11d430a1><span class=\"mr-1\" data-v-11d430a1>2025 © </span><a href=\"#\" class=\"\" data-v-11d430a1>Tamba Group</a>. </div></div></div></div></div></footer>", 1))
  ]))
}
}

})